module.exports = __webpack_public_path__ + "static/media/Q.39ad8c7d.jpg";